import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { selectCartItems } from "./Redux/shoppingCartReducer";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col, Form, Spinner } from "react-bootstrap";
import ShoppingCartComponent from "./ShoppingCart";
import PersonalDetailsFormComponent from "./PersonalDetails";
import apiService from "./services/api.service";
import { useForm } from "react-hook-form";
import CountdownTimer from './CountdownTimer';
import { useCountdown } from './useCountdown';
import moment from "moment";
import { OrderStatus } from "./data/enums";
import Company from "./companyComponents/Company";
import CompanyRegistrationForm from "./companyComponents/CompanyRegistrationForm";
import { eventService } from "./services/event.service";


function RegistrationComponent(props) {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });

  const [lang, setLang] = useState("");
  const [pciIframeSrc, setPciIframeSrc] = useState("");
  const [isPaymentStep, setIsPaymentStep] = useState(false);
  // const [customerId, setCustomerId] = useState(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [orderStatusId, setOrderStatusId] = useState(null)
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  const propertyId = new URLSearchParams(location.search).get("propid") || 0;
  let cartItems = useSelector(selectCartItems);
  let reduxIsPayment = useSelector((state) => state.cart.payment.payload);
  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
  const productBlockingIdentifier = window.sessionStorage.getItem("productBlockingIdentifier");
  const productBlockingIdentifierTime = window.sessionStorage.getItem("productBlockingIdentifierTime");
  const company = useSelector((state) => state.company.company)
  const workers = useSelector((state) => state.company.workers)
  let expSeconds = 60;
  let expMin = 10;
  const expirationTimeTxt = expMin + " " + t("expTimeTxt");
  let EXP_TIME_IN_MS = expMin * expSeconds * 1000;
  const BlockTime_IN_MS = new Date(productBlockingIdentifierTime).getTime();
  const expirationTime = BlockTime_IN_MS + EXP_TIME_IN_MS;
  const [days, hours, minutes, seconds] = useCountdown(expirationTime);
  let RDRCT_TIME_IN_MS = minutes < 0 ? 0 : ((minutes * expSeconds) + (seconds + 3)) * 1000;
  const companyUser = useSelector((state) => state.company.companyUser)
  const PCI_API_DOMAIN = process.env.REACT_APP_PCI_API_DOMAIN;
  const [loading, setLoading] = useState(false)
  const [selectMopMsg, setSelectMopMsg] = useState("")
  const [sendToGifteeTime, setSendToGifteeTime] = useState(null)
  const [sendNow, setSendNow] = useState(true)

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  //handle send gift time 
  useEffect(() => {
    if (!sendNow) {
      if (getValues('gifteeDate') && getValues('gifteeTime')) {
        const date = getValues('gifteeDate')
        const time = getValues('gifteeTime').split(':')
        setSendToGifteeTime(
          moment(date)
            .hour(time[0])
            .minute(time[1])
            .format("YYYY-MM-DD[T]HH:mm:ss"))
      }
    } else {
      setSendToGifteeTime(null)
    }
  }, [watch('gifteeDate'), watch('gifteeTime'), sendNow])

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
    window.addEventListener("message", processIframeResponse, false);
    if (window.parent === window.self) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.parent.postMessage({ toScroll: true }, '*');
      console.info('dispatch event to scroll!');
    }

    if (productBlockingIdentifier) {
      console.log(RDRCT_TIME_IN_MS);
      setTimeout(() => {
        unblockProduct(productBlockingIdentifier);
        history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang")}`);

      }, RDRCT_TIME_IN_MS);

    }
    else {
      history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang")}`);
    }

    return () => {
      window.removeEventListener("message", processIframeResponse);
    };
  }, []);


  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);


  useEffect(() => {
    setIsPaymentStep(reduxIsPayment)
  }, [reduxIsPayment])

  useEffect(() => {
    if (typeof lang === "string" && lang !== "" && isPaymentStep && !companyUser) {

      const payerName = window.sessionStorage.getItem("payerName");
      const payerCompID = window.sessionStorage.getItem("payerCompID");
      getPaymentHTML(payerName, payerCompID);
    }

    if (typeof lang === "string" && lang !== "" && isPaymentStep && companyUser) {

      const payerName = company.companyName
      const payerCompID = company.companyVatNumber;
      getPaymentHTML(payerName, payerCompID);
    }
  }, [isPaymentStep, lang]);




  const onInsertCartInProgressComplete = () => {
    setIsPaymentStep(true);
  };

  const unblockProduct = (productBlockingIdentifier) => {
    sessionStorage.removeItem('productBlockingIdentifier');
    sessionStorage.removeItem('productBlockingIdentifierTime');
    sessionStorage.removeItem('products');

    apiService.unblockProduct(productBlockingIdentifier).then(
      (response) => {

      },
      (error) => { });
  };

  const completeOrder = (bookingID) => {
    let orderNUm = bookingID || sessionStorage.getItem("lastOrderNum") || 0;
    let productLastSearchId =
      sessionStorage.getItem("productLastSearchId") || 0;
    let searchesArray = [];
    searchesArray.push(productLastSearchId);
    let lastCustomer = sessionStorage.getItem("lastCustomer") || null;
    if (companyUser) {
      sessionStorage.setItem("orderStatusId", OrderStatus.Reserved)
      apiService.updateOrders(chainId, orderNUm, OrderStatus.Reserved, null).then(() => {
        history.push(
          `/confirmation?chainid=${chainId}&lang=${new URLSearchParams(
            location.search
          ).get("lang")}`
        );
      })
        .catch((err) => {
          console.error(err);
          alert("Failed to complete Company order.");
        });
    }
    if (lastCustomer && !companyUser) {
      var updatedCustomer = JSON.parse(lastCustomer);
      apiService.getCustomer(updatedCustomer.customerEmail).then(
        (response) => {
          if (response.data.data && response.data.data.length > 0) {
            var custId =
              response.data.data[response.data.data.length - 1].customerId;
            // setCustomerId(custId);

            //update the order number and customerid in searches table
            apiService.insertSearch(
              null,
              productLastSearchId,
              orderNUm,
              custId,
              false,
              null
            );

            updatedCustomer.customerId = custId;
            let firstProduct = cartItems[Object.keys(cartItems)[0]];

            // update order status , searches and customerID
            apiService
              .updateOrder(
                chainId,
                orderNUm,
                OrderStatus.Reserved,
                null,
                searchesArray,
                updatedCustomer,
                firstProduct && firstProduct.selectedProduct.propertyId ? firstProduct.selectedProduct.propertyId : 0,
              )
              .then((res) => {
                history.push(
                  `/confirmation?chainid=${chainId}&lang=${new URLSearchParams(
                    location.search
                  ).get("lang")}`
                );
              })
              .catch((err) => {
                console.error(err);
                alert("Failed to complete order.");
              });
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          alert("Failed to complete order.");
        }
      );
    }
  };

  const processIframeResponse = (event) => {
    let completedOrder = sessionStorage.getItem("completedOrder") || null;
    if (event.origin !== PCI_API_DOMAIN || completedOrder) return;
    // Parse message back to json
    const messageObject = JSON.parse(event.data);
    if (messageObject.action == "pciReponse" && messageObject.result == true && !completedOrder) {
      completeOrder(messageObject.bookingID);
      sessionStorage.setItem("completedOrder", "true");

      const firstCartItemKey = Object.keys(cartItems)[0];
      const product = cartItems[firstCartItemKey]?.selectedProduct;
      
      eventService.addPaymentInfo(product);
    }
    else {
      alert(t("paymentFailed") + " , " + messageObject.description);
      const payerName = window.sessionStorage.getItem("payerName");
      const payerCompID = window.sessionStorage.getItem("payerCompID");

      if (payerName && payerName.length && payerCompID) {
        getPaymentHTML(payerName, payerCompID);
      }
      else {
        getPaymentHTML("");
      }
    }
  };
  const getPCIframe = (chainId, orderNUm, payBy, payerCompID, isGroupId) => {

    setLoading(true)
    let firstProduct = cartItems[Object.keys(cartItems)[0]];
    apiService
      .getPCIframe(
        chainId,
        new URLSearchParams(location.search).get("lang"),
        propertyId > 0 ? propertyId : firstProduct && firstProduct.selectedProduct.propertyId ? firstProduct.selectedProduct.propertyId : 0,
        orderNUm,
        payBy,
        payerCompID,
        isGroupId,
      )
      .then(
        (response) => {
          let iframeSrc = response.data.data;
          setPciIframeSrc(iframeSrc);
          setLoading(false)
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false)
        }
      );
  }
  const findOrCreateCustomer = (email) => {
    return new Promise((resolve) => {
      apiService.getCustomer(email)
        .then((response) => {
          if (response.data.data && response.data.data.length) {
            resolve(response.data.data[0].customerId)
          } else {
            const customer = {
              customerAddress: company.companyAddress,
              customerCity: company.companyCity,
              customerCountry: company.companyCountry,
              customerEmail: companyUser.email,
              customerFirstName: companyUser.firstName,
              customerId: 0,
              customerIdentification: company.companyVatNumber,
              customerLanguageIsoCode: company.companyContactLanguageIsoCode,
              customerLastName: companyUser.lastName,
              customerPhone: companyUser.phoneNumber,
              customerPostalCode: company.companyPostalCode,
              companyId: company.companyId
            }
            apiService.setCustomer(customer).then((response) => {
              resolve(response.data.data)
            })
          }
        })
    })
  }

  const getPaymentHTML = (payBy, payerCompID) => {
    let orderNUm = sessionStorage.getItem("lastOrderNum") || 0;
    if (!orderStatusId) {
      setSelectMopMsg(t("choosePaymentMethod"))
    }
    if (companyUser && company && orderStatusId) {
      setSelectMopMsg("")
      setLoading(true)
      let customerIp;
      let giftees = []
      if (workers) {
        workers.map((worker) => {
          giftees.push(
            {
              gifteeEmail: worker.workerEmail,
              gifteeName: worker.workerFirstName + " " + worker.workerLastName,
              gifteePhone: worker.workerPhone,
            })
        })

      }

      apiService.getUserIp()
        .then
        ((r) => {
          customerIp = r
          let payerName = company.companyName
          let productId = (Object.keys(cartItems)[0])
          let quantity = (Object.values(cartItems)[0].qty)
          let languageIsoCode = lang
          let customerBrowserAgent = null
          let gifteeMsg = null

          let customerId = null
          let isProductAvailable = false;
          findOrCreateCustomer(companyUser.customerEmail).then((response) => {
            customerId = response

            if (productBlockingIdentifier && productId) {
              apiService.getBlockedProduct(productId, productBlockingIdentifier)
                .then(response => {
                  if (!response.errors && response.data && response.data.data) {
                    if (response.data.data[0].isValid) {
                      isProductAvailable = true;
                    }
                  }
                })
                .finally(() => {
                  if (isProductAvailable) {
                    apiService.setOrders(chainId, productId, quantity, gifteeMsg, languageIsoCode, customerIp, customerBrowserAgent, orderStatusId, giftees, sendToGifteeTime, company.companyId, customerId)
                      .then((r) => {
                        orderNUm = r.data.data.groupOrderId
                        sessionStorage.setItem("lastOrderNum", orderNUm)
                        sessionStorage.setItem("orderStatusId", orderStatusId)

                        if (orderStatusId == OrderStatus.Pending) {
                          history.push(
                            `/confirmation?chainid=${chainId}&lang=${new URLSearchParams(
                              location.search
                            ).get("lang")}`
                          );
                        } else {
                          getPCIframe(chainId, orderNUm, company.companyName, company.companyId, true)
                        }
                      })
                  } else {
                    alert(t("productNotAvailableAnymore"));
                  }
                })
            }
          })
        })
        .finally(() => setLoading(false));
    }
    if (!companyUser) {
      getPCIframe(chainId, orderNUm, payBy, payerCompID, false)
    }
  }
  const scrollToReg = () => {
    const element = document.getElementById('reg');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToReg()
  }, [])





  return (
    <div className="registration-page-wrap">
      <Row className="col-container">
        <Col className="box-wrap">
          <div className="box rvs-dtl">
            {companyUser &&
              <div className="hidden-desk">
                <Company />
                <div className="border-underline-big"></div>
              </div>
            }
            {companyUser ?
              <h2 aria-label={t("ReservationDetails")} className="top-line comp-color">{t("ReservationDetails")}</h2>
              :
              <h2 aria-label={t("ReservationDetails")} className="top-line">{t("ReservationDetails")}</h2>
            }
            <ShoppingCartComponent
              setValue={setValue}
              sendNow={sendNow}
              setSendNow={setSendNow}
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
            ></ShoppingCartComponent>
          </div>
        </Col>
        <Col lg="4" className="box-wrap">
          {!companyUser ? <>
            <div className="box reg-form">
              <h2 aria-label={!isPaymentStep ? t("userDetails") : t("PaymentDetails")} className="top-line">
                {!isPaymentStep ? t("userDetails") : <Row> <Col>{t("PaymentDetails")} </Col> <Col className="secured-pay-wrap"><span className="pay-icn"> </span> <span className="pay-txt">{t("securePay")}</span></Col></Row>}

              </h2>
              {productBlockingIdentifier ?
                <div className="count-down-wrap">
                  <div role="application" aria-roledescription={t("attention")} aria-label={t("ExpirationText").replace("[0]", expirationTimeTxt)}>{t("ExpirationText").replace("[0]", expirationTimeTxt)} </div>
                  <span role="application" aria-roledescription={t("attention")} aria-label={t("RemainedExpirationTimeText") + (new Date(RDRCT_TIME_IN_MS).getMinutes() + " " + t("Mins")) + " " + (new Date(RDRCT_TIME_IN_MS).getSeconds() - 3 + " " + t("Seconds"))}>{t("RemainedExpirationTimeText")}</span>
                  <CountdownTimer targetDate={expirationTime} />
                </div>

                : ""}
              {!isPaymentStep && (
                <PersonalDetailsFormComponent
                  register={register}
                  errors={errors}
                  handleSubmit={handleSubmit}
                  onInsertCartInProgressComplete={onInsertCartInProgressComplete}
                  completeOrder={completeOrder}
                  setValue={setValue}
                  setLoading={setLoading}
                  loading={loading}
                  sendToGifteeTime={sendToGifteeTime}
                ></PersonalDetailsFormComponent>
              )}
              {isPaymentStep && (
                <div id="pci-iframe-holder">
                  <iframe
                    frameBorder={0}
                    scrolling="yes"
                    allowtransparency="true"
                    src={pciIframeSrc}
                  ></iframe>
                  <h4 className="orderNameMsg" dangerouslySetInnerHTML={{ __html: t("orderNameMsg").replace('\n', "<br/>").replace("&nbsp;", "&nbsp;").replaceAll("'", JSON.stringify("").charAt(0)) }}></h4>
                </div>
              )}
            </div>
          </>
            :
            <>
              {companyUser && !pciIframeSrc &&
                <CompanyRegistrationForm
                  loading={loading}
                  company={company}
                  companyUser={companyUser}
                  selectMopMsg={selectMopMsg}
                  orderStatusId={orderStatusId}
                  getPaymentHTML={getPaymentHTML}
                  expirationTime={expirationTime}
                  setOrderStatusId={setOrderStatusId}
                  RDRCT_TIME_IN_MS={RDRCT_TIME_IN_MS}
                  expirationTimeTxt={expirationTimeTxt}
                  productBlockingIdentifier={productBlockingIdentifier}
                />
              }
              {pciIframeSrc && orderStatusId != OrderStatus.Pending &&
                <div className="box reg-form">
                  <h2 className="top-line">
                    <Row> <Col>{t("PaymentDetails")} </Col> <Col className="secured-pay-wrap"><span className="pay-icn"> </span> <span className="pay-txt">{t("securePay")}</span></Col></Row>
                  </h2>
                  <div id="pci-iframe-holder">
                    <iframe
                      frameBorder={0}
                      scrolling="yes"
                      allowtransparency="true"
                      src={pciIframeSrc}
                    ></iframe>
                    <h4 className="orderNameMsg" dangerouslySetInnerHTML={{ __html: t("orderNameMsg").replace('\n', "<br/>").replace("&nbsp;", "&nbsp;").replaceAll("'", JSON.stringify("").charAt(0)) }}></h4>
                  </div>
                </div>
              }
            </>
          }
        </Col>
      </Row>
    </div>
  );
}

export default RegistrationComponent;
